import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._b({staticClass:"custom-button",class:_vm.classList,attrs:{"depressed":"","icon":_vm.variant === 'icon',"outlined":_vm.variant === 'secondary',"text":_vm.variant === 'text',"data-test":_vm.dataTestAttr,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }